import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AccountFacade } from '@mode/accounts/contract';
import { NavMenuService } from '@mode/accounts/feature-header';
import { ReportViewerFacade } from '@mode/report-viewer/domain';
import { ReportFacade } from '@mode/reports/domain';
import { NewContainerMenuItem } from '@mode/shared/ui';
import { getCurrentUsername } from '@mode/shared/util-js';
import { AnalyticsEvent, PAGE_CONTEXT } from '@mode/shared/util-segment';
import { Observable, map } from 'rxjs';
import { first } from 'rxjs/operators';

/* eslint-disable @angular-eslint/component-selector */
@Component({
  selector: 'mode-report-view-root',
  templateUrl: './root.component.html',
  styleUrls: ['./root.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RootComponent implements OnInit {
  orgName = '';
  reportToken = '';

  orgContext$ = this.accountFacade.currentOrg$;
  reportContext$ = this.accountFacade.reportOwner$;
  userContext$ = this.accountFacade.user$;
  navOpen$ = this.navMenuService.navState();
  isLoggedIn$ = this.accountFacade.isLoggedIn$;
  reportBreadcrumbs$ = this.reportFacade.datasetBreadcrumbs$;
  report$ = this.reportFacade.report$;
  newMenuContainerItems$!: Observable<NewContainerMenuItem[]>;
  private reportRunToken = '';

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private route: ActivatedRoute,
    private accountFacade: AccountFacade,
    private reportFacade: ReportFacade,
    private reportViewerFacade: ReportViewerFacade,
    private navMenuService: NavMenuService,
    @Inject(PAGE_CONTEXT) private pageContext: string
  ) {}

  openNav(): void {
    this.navMenuService.open();
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.orgName = params['orgName'];
      this.reportToken = params['reportToken'];
      this.reportRunToken = this.route.firstChild?.snapshot.params['reportRunToken'];

      this.accountFacade.loadCurrentUser(getCurrentUsername(this.document));
      // Init account report owner
      this.accountFacade.loadReportOwner(this.orgName);
      // Init basic report information for header and report iframe layout
      this.reportFacade.reportViewRouteLoadReport(this.orgName, this.reportToken);

      this.reportViewerFacade.reportViewRouteLoadReportRun(this.orgName, this.reportToken, this.reportRunToken);
    });

    this.newMenuContainerItems$ = this.orgContext$.pipe(
      first(),
      map(({ username }) => {
        return [
          {
            href: `/editor/reports/new`,
            text: 'Report',
            icon: 'icon-report-builder',
            class: 'new-report',
            testAttribute: 'create-new-report',
            trackClickData: {
              location: this.pageContext,
              action: AnalyticsEvent.Name.NewReport,
            },
          },
          {
            href: `/editor/${username}/datasets/new`,
            text: 'Dataset',
            icon: 'icon-dataset',
            class: 'new-dataset',
            testAttribute: 'create-new-dataset',
            trackClickData: {
              location: this.pageContext,
              action: AnalyticsEvent.Name.NewDataset,
            },
          },
        ];
      })
    );
  }
}
